import { ITableColumn } from '@makyoapp/makyo-sdk/models/Table'

import { Cell, ICell } from '.'

export type TSlugSettings = {
  slugColumn: string
  rowId: string
}

export interface ISlug extends ITableColumn {
  Settings: TSlugSettings
}

export interface ISlugCell extends ICell {
  settings: TSlugSettings
}

export class SlugCell implements ISlugCell {
  value: Cell
  settings: TSlugSettings

  constructor(value: string | number | boolean | Date | null, settings: TSlugSettings) {
    this.value = value
    this.settings = {
      slugColumn: settings.slugColumn,
      rowId: settings.rowId,
    }
  }

  toString(): string {
    // If the value is null or undefined, return an empty string
    if (this.value === null || this.value === undefined) {
      return ''
    }

    // Convert value to string
    let strValue = String(this.value)

    // Handle Date objects by converting to ISO string
    if (this.value instanceof Date) {
      strValue = this.value.toISOString()
    }

    // Transform into a URL-friendly slug:
    // 1. Convert to lowercase
    // 2. Replace spaces with dashes
    // 3. Remove special characters (non-alphanumeric except dashes)
    let slug = strValue
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with dashes
      .replace(/[^a-z0-9\-]/g, '') // Remove all non-alphanumeric characters except dashes
      .replace(/^-+|-+$/g, '') // Remove leading and trailing dashes

    return `${this.settings.rowId.slice(-6)}-${slug}`
  }

  toCell<T extends Cell>(newValue: T) {
    if (!newValue || typeof newValue !== 'string') {
      this.value = ''
      return this
    }
    this.value = newValue
    return this
  }
}
